import type { MetricOperator, ScopeOption, ScopeState } from './types';

export const DATE_PRESETS: ScopeOption[] = [
  { id: '7', label: 'Last 7 days' },
  { id: '14', label: 'Last 14 days' },
  { id: '30', label: 'Last 30 days' },
  { id: '60', label: 'Last 60 days' },
  { id: '90', label: 'Last 90 days' },
];

export const METRIC_OPERATORS = [
  '<',
  '>',
  '=',
  '≥',
  '≤',
] as const satisfies readonly MetricOperator[];

export const DEFAULT_SCOPE: ScopeState = {
  brand: [],
  account: [],
  platform: [],
  creativeType: [],
  range: { mode: 'preset', preset: '30', from: '', to: '' },
  leadingKpi: 'ctr',
};
